<nz-collapse [nzBordered]="false" class="key-item-collapse medium-header-padding company-employees">
  <nz-collapse-panel #employeesPanel [nzActive]="true" [nzShowArrow]="false" [nzHeader]="employeesHeaderTmpl">
    <ng-template #employeesHeaderTmpl>
      <app-collapse-panel-header [minHeight]="'0px'" [panelActive]="employeesPanel.nzActive"
                                 [onlyText]="'Empleados asociados'"></app-collapse-panel-header>
    </ng-template>

    <!-- Asociar (solo en edicion) -->
    <div *ngIf="editable" class="add-employee-action">
      <button nz-button nzType="default" nzShape="round" nzSize="default" type="button"
              [nzLoading]="loadingAvailable" (click)="openAddEmployeesModal()">
        <app-st-icon *ngIf="!loadingAvailable" class="prefix" [bold]="true" name="add"></app-st-icon>
        Asociar empleados
      </button>
    </div>

    <nz-skeleton *ngIf="loading" [nzActive]="true" [nzParagraph]="{ rows: 3 }"></nz-skeleton>

    <ng-container *ngIf="!loading">
      <div *ngIf="employees.length; else noEmployees" class="employee-list">
        <div *ngFor="let employee of employees; trackBy: trackByEmployeeId" class="employee-row">
          <nz-avatar [nzSize]="40"
                     [nzSrc]="employee.avatar ? getSafeImageUrl(employee.avatar) : undefined"
                     [nzText]="!employee.avatar ? getInitials(employee) : undefined"
                     [style.backgroundColor]="!employee.avatar ? '#ffffff' : undefined"
                     [style.color]="!employee.avatar ? '#000000' : undefined"
                     [style.border]="!employee.avatar ? '1px solid #d9d9d9' : undefined"
                     [style.fontWeight]="!employee.avatar ? '600' : undefined"></nz-avatar>

          <div class="employee-name">
            <span class="text-label-14 text-semibold">{{ getFullName(employee) }}</span>
          </div>

          <div class="employee-position text-label-14">{{ employee.position || '-' }}</div>

          <div class="employee-state text-label-14">{{ employee.isActive ? 'Activo' : 'Inactivo' }}</div>

          <button *ngIf="editable" class="employee-remove" nz-button nzType="text" nzShape="circle" type="button"
                  nz-tooltip nzTooltipTitle="Desasociar"
                  [nzLoading]="removingEmployeeId === employee.id"
                  [disabled]="removingEmployeeId !== null"
                  (click)="askRemoveEmployee(employee)">
            <app-st-icon *ngIf="removingEmployeeId !== employee.id" [bold]="true" name="delete"></app-st-icon>
          </button>
        </div>
      </div>

      <ng-template #noEmployees>
        <div class="employees-empty text-label-14">Esta empresa no tiene empleados asociados.</div>
      </ng-template>
    </ng-container>
  </nz-collapse-panel>
</nz-collapse>

<!-- Confirmacion de desasociar: quitar la asociacion NO elimina el contacto -->
<app-confirmation-modal #removeEmployeeConfirmationModal
                        (confirmed)="onRemoveEmployeeConfirmed()"></app-confirmation-modal>

<!-- Modal: asociar empleados (seleccion multiple) -->
<ng-template #addEmployeesModalTmpl>
  <div class="add-employees-modal">
    <div class="flex-center-between" style="margin-bottom: 24px;">
      <h2 class="text-header-18">Asociar empleados</h2>
      <app-st-icon *ngIf="!savingEmployees" (click)="closeAddEmployeesModal()" class="cursor-pointer" name="close"
                   [bold]="true"></app-st-icon>
    </div>

    <div style="margin-bottom: 16px;">
      <div class="search-preffix search">
        <input type="text" nz-input nzSize="large" placeholder="Buscar por nombre o email….."
               [disabled]="savingEmployees"
               [ngModel]="employeeSearchText" (ngModelChange)="onEmployeeSearchChange($event)" />
      </div>
    </div>

    <div style="max-height: 400px; overflow-y: auto;">
      <div *ngFor="let employee of filteredAvailableEmployees; trackBy: trackByEmployeeId" class="employee-card"
           [class.selected]="selectedEmployeesIds.has(employee.id)">
        <div class="flex-center gap-100" style="width: 100%;">
          <label nz-checkbox [nzChecked]="selectedEmployeesIds.has(employee.id)"
                 [nzDisabled]="savingEmployees"
                 (nzCheckedChange)="toggleEmployeeSelection(employee.id, $event)"></label>
          <nz-avatar [nzSize]="40"
                     [nzSrc]="employee.avatar ? getSafeImageUrl(employee.avatar) : undefined"
                     [nzText]="!employee.avatar ? getInitials(employee) : undefined"
                     [style.backgroundColor]="!employee.avatar ? '#ffffff' : undefined"
                     [style.color]="!employee.avatar ? '#000000' : undefined"
                     [style.border]="!employee.avatar ? '1px solid #d9d9d9' : undefined"
                     [style.fontWeight]="!employee.avatar ? '600' : undefined"></nz-avatar>
          <div class="flex flex-column" style="flex: 1;">
            <span class="text-label-14 text-semibold">{{ getFullName(employee) }}</span>
            <span *ngIf="employee.email" class="text-label-12" style="color: #666666;">{{ employee.email }}</span>
          </div>
        </div>
      </div>

      <div *ngIf="!filteredAvailableEmployees.length" class="employees-empty text-label-14"
           style="padding: 40px; text-align: center;">
        {{ employeeSearchText ? 'Ningún empleado coincide con la búsqueda.' : 'No hay empleados disponibles para asociar.' }}
      </div>
    </div>

    <div class="flex-center-between footer" style="margin-top: 24px; padding-top: 16px; border-top: 1px solid #e9ecef;">
      <button nz-button nzType="text" nzShape="round" nzSize="large" type="button"
              [disabled]="savingEmployees" (click)="closeAddEmployeesModal()">
        Cancelar
      </button>
      <button nz-button nzType="primary" nzShape="round" nzSize="large" type="button"
              class="text-btn-14" [nzLoading]="savingEmployees"
              [disabled]="selectedEmployeesIds.size === 0" (click)="confirmAddEmployees()">
        Asociar ({{ selectedEmployeesIds.size }})
      </button>
    </div>
  </div>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
             [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
             [msg]="toastConfig.msg"></app-toast>
</ng-template>
